module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[82]81.576ac8f.woff2";